export const ORANGE = "#FF9015";
export const LONG_PRESS_DELAY = 500;
export const HEADER_HEIGHT = 68;

// Dimensions by view
export const WEEKLY_COLLAB_COL = 80;
export const WEEKLY_DAY_COL = 70;
export const MONTHLY_COLLAB_COL = 72;
export const MONTHLY_DAY_COL = 48;
export const ROW_HEIGHT = 72;
